import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Virtuoso } from 'react-virtuoso';
import PropTypes from 'prop-types';

import { ContactFooter } from 'components/atoms/ContactsFooter';
import { ScrollBox } from 'components/atoms/ScrollBox';
import { ContactCard } from '../../components/organisms/contactCard';

export const ContactsCard = ({
  data,
  queryParams,
  selectedRows,
  onChangeSelectedContact,
  showAddToLisButton,
  list,
  deleteContactFromList,
  page,
  meta,
  isFetching,
  activeNetwork,
  onLoadMore,
  listId,
  type,
  disabledContacts,
}) => {
  const route = useRouteMatch();

  const history = useHistory();
  return (
    <ScrollBox
      as={Virtuoso}
      flex="1"
      data={data}
      style={{ height: 'calc(100%)' }}
      sx={{
        '& > div ': {
          paddingRight: '16px',
        },
      }}
      increaseViewportBy={400}
      itemContent={(index, contact) => (
        <ContactCard
          isSelectDisabled={disabledContacts?.includes?.(contact.id)}
          type={type}
          index={index}
          queryParams={queryParams}
          contact={contact}
          isSelected={selectedRows.includes(index) || selectedRows.includes(contact.id)}
          onChangeSelected={() => onChangeSelectedContact(index, contact)}
          showAddToLisButton={showAddToLisButton}
          list={list}
          deleteContactFromList={deleteContactFromList}
          showEmailDropdown={type !== 'public'}
          page={page}
          showDetail={(path = '') => {
            if (page === 'list') {
              history.push(
                `/networks/${activeNetwork.slug}/list/${list.id}/contacts/${contact.id}${path}${history.location.search}`,
              );
              return;
            }

            if (page === 'list:add') {
              history.push(
                `/networks/${activeNetwork.slug}/list/${list.id}/add-contacts/${contact.id}${path}${history.location.search}`,
              );
              return;
            }

            if (type === 'public') {
              history.push(`/shared-lists/${list.slug}/${contact.id}${path}${history.location.search}`);
              return;
            }

            history.push(`${route.path}/${contact.id}${path}${history.location.search}`);
          }}
          sx={{
            pl: '16px',
          }}
        />
      )}
      components={{
        // eslint-disable-next-line react/no-multi-comp
        Footer: () => (
          <ContactFooter
            isLoading={isFetching}
            allContactsCount={data.length}
            contactsTotal={meta?.queryTotal ?? 0}
            filters={queryParams.filters}
            isList={Boolean(listId)}
          />
        ),
      }}
      endReached={() => {
        if (isFetching) {
          return;
        }

        onLoadMore();
      }}
    />
  );
};

ContactsCard.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  queryParams: PropTypes.object.isRequired,
  selectedRows: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChangeSelectedContact: PropTypes.func.isRequired,
  showAddToLisButton: PropTypes.bool.isRequired,
  list: PropTypes.object.isRequired,
  deleteContactFromList: PropTypes.func.isRequired,
  page: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  activeNetwork: PropTypes.object.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  listId: PropTypes.string.isRequired,
  type: PropTypes.string,
  disabledContacts: PropTypes.array,
};

ContactsCard.defaultProps = {
  type: 'default',
  disabledContacts: [],
};
